// /src/store/demoManagment/types.ts

export const UPDATE_BOOLEAN_MAP = 'UPDATE_BOOLEAN_MAP';

export interface BooleanMapState {
  booleanMap: { [key: string]: boolean };
}

export const initialState: BooleanMapState = {
  booleanMap: {
    'SVOD'               : false,
    Diffusion                : false,
 //   Restream                 : false,

    Boutique                 : false,
    'Campagne QRcode/CTA'    : false,
    'Gestion des annonceurs' : false,
    'Compagnon IA'           : false,
    
    Chat                     : false,
    Sondage                  : false,
  },
};

export interface UpdateBooleanMapAction {
  type: typeof UPDATE_BOOLEAN_MAP;
  payload: {
    key: string;
    value: boolean;
  };
}

export type BooleanMapActionTypes = UpdateBooleanMapAction;
